import classnames from 'classnames';
import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';

import Button, { ButtonTypes } from 'components/common/button';
import CSSTransitionGroup from '../../lib/css_transition_group';
import DomControls from 'components/lib/dom_controls/dom_controls';
import PageLayout from '../../page_layout';

const AdminTable = createReactClass({
  /* PROPS
    binding: <binding> binding for an Immutable List with items representing rows
    className?: <string> class to be applied to component
    editorClassName?: <string> class to be applied to editor
    isCreatable: <boolean> is creation possible for this property
    itemAsRow: <function> accepts an immutable item corresponding to a row and returns a plain JS object
                          {id, name, value, highlight?, hideEditButton?} from the immutable
    itemCompare?: <function> accepts two immutable items for row ordering: `itemCompare(lhsImm, rhsImm)`
                             and sorts on 'name' field by default
    filterer?: <function> accepts an item and a value and filters items with fields that match that value
    hasPendingState: <function> returns true if there's uncommitted state to keep the editor open
    onOpenEditor?: <function> accepts an id of the item being edited; use to set up the editor state, if needed
    onTrash?: <function> accepts an id and is called when trash button is clicked
    optionalColumns?: <function> takes in immutable observation and returns react components
    optionalPreHeader?: <react component> optional component to render about title e.g. toggle
    optionalValueLabel?: <string> label to be displayed next to value
    renderCustomEditControls: <function> accepts an immutable item corresponding to a row and returns the custom edit
                            controls to be rendered
    renderEditor: <function> accepts an id and returns react component that allows editing of properties
    subjectName: <string> name of subject admin pane is for
  */

  mixins: [Morearty.Mixin],

  /* lifecycle */
  UNSAFE_componentWillMount() {
    let viewBinding = this.getViewBinding();
    viewBinding.set('openEditor', false);
    viewBinding.set('editorId', null);
    viewBinding.set('filter', '');
  },

  /* render */
  render() {
    let binding = this.getDefaultBinding();
    let classes = classnames('adminTable', this.props.className);

    let adminTableRows = (binding.get() && this.renderAdmin(binding.get())) || [];
    let adminTableRowsCount = adminTableRows.length;

    return (
      <PageLayout className={classes} showLoading={this.hasPendingResponse(this.getViewBinding().get('editorId'))}>
        <div className="adminTable-page">
          <div className="adminTable-pageHead">
            <div className="adminTable-pageHead-left">
              {this.renderPreHeader()}
              <div className="adminTable-pageHead-controls">
                <div className="adminTable-title">
                  {this.props.pluralSubjectName ? this.props.pluralSubjectName : `${this.props.subjectName}s`}
                </div>
                <div className="adminTable-spacer" />
                {this.renderAddButton()}
              </div>
              {this.renderAdminHeader(adminTableRowsCount)}
            </div>
            {this.renderSlidingEditor()}
          </div>
          <div className="adminTable-container">{adminTableRows}</div>
        </div>
      </PageLayout>
    );
  },

  renderPreHeader() {
    return this.props.optionalPreHeader || null;
  },

  renderAdminHeader(count) {
    let viewBinding = this.getViewBinding();

    let isFiltering = viewBinding.get('filter') !== '';
    let pluralSubjectName = this.props.pluralSubjectName ? this.props.pluralSubjectName : `${this.props.subjectName}s`;
    let subjectName = count === 1 ? this.props.subjectName : pluralSubjectName;
    let countDescriptor = isFiltering ? `matching ${subjectName}` : `${subjectName} total`;

    return (
      <div className="adminTable-header">
        {this.renderColumnHeaders(count, countDescriptor)}
        <div className="adminTable-header-filter-container">
          <DomControls.Controlled.input
            binding={viewBinding.sub('filter')}
            className="adminTable-header-filter"
            placeholder="Filter results"
            type="text"
          />
          <div className="icon-search universalSearch-searchBar-icon" />
        </div>
      </div>
    );
  },

  renderColumnHeaders(count, countDescriptor) {
    if (!this.props.optionalColumnHeaderNames) {
      return <div className="adminTable-header-count">{`${count} ${countDescriptor}`}</div>;
    }

    return this.props.optionalColumnHeaderNames.map((header, idx) => {
      return (
        <div key={idx} className="adminTable-header-count">
          {header}
        </div>
      );
    });
  },

  renderAdmin(immList) {
    let itemCompare = this.props.itemCompare || this.defaultItemCompare;

    let filter = this.getViewBinding().get('filter');
    let filterRegExp = filter ? new RegExp(filter.replace(/\s/g, '').replace(/([()[{*+.$^\\|?])/g, '\\$1'), 'i') : null;
    let filterer = this.props.filterer || this.filterer;

    let filteredList = immList
      .sort(itemCompare)
      .filter(item => filterer(filterRegExp, this.props.itemAsRow ? this.props.itemAsRow(item) : item.toJS()));

    return filteredList.map(item => this.renderRow(item)).toArray();
  },

  defaultItemCompare(lhsImm, rhsImm) {
    let lhsValue = lhsImm.get('name') || '';
    let rhsValue = rhsImm.get('name') || '';

    return lhsValue.localeCompare(rhsValue);
  },

  renderAddButton() {
    if (this.props.isCreatable && this.props.renderAddButton) {
      return this.props.renderAddButton();
    }

    return this.props.isCreatable ? (
      <Button className="adminTable-addButton" onClick={this.onAddClick} buttonType={ButtonTypes.SECONDARY}>
        Add {this.props.subjectName}
      </Button>
    ) : null;
  },

  renderRow(itemImm) {
    let row = this.props.itemAsRow ? this.props.itemAsRow(itemImm) : itemImm.toJS();
    let id = row.id;

    let classNames = classnames(
      'adminTable-row',
      {
        'adminTable-row-highlight': row.highlight,
        'adminTable-row-selected': id === this.getViewBinding().get('editorId') && this.shouldOpenEditor(),
      },
      row.classNames
    );

    let valueContentClassNames = classnames({ 'adminTable-row-value-contents': !this.props.isChannelTable });

    return (
      <div
        className={classNames}
        key={`admin-row-${id}`}
        onClick={row.hideEditButton ? () => {} : this.openEditor.bind(null, id)}
      >
        <div className="adminTable-row-main">
          <div className="adminTable-row-name" title={row.name}>
            {row.name}
          </div>
          <div className="adminTable-row-value">
            {this.props.optionalValueLabel ? `${this.props.optionalValueLabel}: ` : null}
            <div className={valueContentClassNames}>{row.value}</div>
          </div>
        </div>
        {this.renderSecondaryColumns(itemImm)}
        {this.props.renderCustomEditControls
          ? this.props.renderCustomEditControls(itemImm)
          : this.renderDefaultEditControls(row)}
      </div>
    );
  },

  renderDefaultEditControls(row) {
    return (
      <div className="adminTable-row-editControls">
        {this.props.onTrash ? this.renderTrash(row.id) : null}
        {row.hideEditButton ? null : this.renderEditButton(row.id)}
      </div>
    );
  },

  renderEditButton(id) {
    return (
      <Button
        id={`adminTableEditButton-${id}`}
        className="adminTable-edit-button"
        onClick={this.openEditor.bind(null, id)}
        buttonType={ButtonTypes.TEXT}
      >
        edit
      </Button>
    );
  },

  renderSecondaryColumns(itemImm) {
    if (this.props.optionalColumns) {
      return <div className="adminTable-row-secondaryColumns">{this.props.optionalColumns(itemImm)}</div>;
    }
    return null;
  },

  renderTrash(id) {
    return (
      <Button
        id={`adminTableTrashButton-${id}`}
        className="adminTable-trashButton"
        onClick={this.onTrash.bind(null, id)}
      >
        <i className="fa fa-lg fa-trash-o" />
      </Button>
    );
  },

  renderSlidingEditor() {
    return [
      <CSSTransitionGroup
        key="adminTable-openEditorSpacer"
        transitionName="adminTable-openEditorSpacer"
        transitionAppear
        transitionAppearTimeout={1000}
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}
      >
        {this.shouldOpenEditor() ? <div className="adminTable-editorSpacer" /> : null}
      </CSSTransitionGroup>,
      <CSSTransitionGroup
        key="adminTable-openEditor"
        transitionName="adminTable-openEditor"
        transitionAppear
        transitionAppearTimeout={1000}
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}
      >
        {this.shouldOpenEditor()
          ? this.renderEditor(
              this.getDefaultBinding()
                .meta('_view')
                .get('editorId')
            )
          : null}
      </CSSTransitionGroup>,
    ];
  },

  shouldOpenEditor() {
    let viewBinding = this.getViewBinding();
    let openStatus = viewBinding.get('openEditor');
    return openStatus === 'open' || (openStatus === 'submitted' && this.hasPendingState(viewBinding.get('editorId')));
  },

  hasPendingResponse(id) {
    return this.props.hasPendingResponse && this.props.hasPendingResponse(id);
  },

  hasPendingState(id) {
    return this.props.hasPendingState && this.props.hasPendingState(id);
  },

  renderEditor(id) {
    let classes = classnames('adminTable-editor', this.props.editorClassName);
    return React.cloneElement(this.props.renderEditor(id, this.closeEditor), {
      className: classes,
    });
  },

  /* helpers */
  onAddClick() {
    this.openEditor(null);
  },

  onTrash(id, event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onTrash(id);
  },

  openEditor(id) {
    if (this.props.onOpenEditor) {
      this.props.onOpenEditor(id);
    }
    let viewBinding = this.getViewBinding();
    viewBinding.set('openEditor', this.hasPendingState(id) ? 'submitted' : 'open');
    viewBinding.set('editorId', id);
  },

  closeEditor(status) {
    let viewBinding = this.getViewBinding();
    if (status === 'submitted') {
      viewBinding.set('openEditor', status);
    } else {
      viewBinding.set('openEditor', null);
      viewBinding.set('editorId', null);
    }
  },

  getViewBinding() {
    return this.getDefaultBinding().meta('_view');
  },

  filterer(filterRegExp, item) {
    let name = item.name ? item.name.replace(/\s/g, '') : '';
    let value = item.value ? item.value.replace(/\s/g, '') : '';
    return filterRegExp ? filterRegExp.test(name) || filterRegExp.test(value) : true;
  },
});

export default AdminTable;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/lib/admin_table.jsx